import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import Swal from "sweetalert2";
import Loader from "../../../../../customComponents/CustomLoader";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";

const EditPaymentTerms = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [paymentType, setPaymentType] = useState([]);
  const navigate = useNavigate();
  const Token = localStorage.getItem("authToken");
  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");
  const authToken = localStorage.getItem("authToken");
  const location = useLocation();
  const { data } = location.state || {};

  useEffect(() => {
    userTypedropdown();
  }, []);

  const userTypedropdown = async () => {
    try {
      const response = await axiosInstance.get("/bp-onboard/bplist", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.onboard_id,
        label: user.bp_name,
      }));
      setUserTypedd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchPAymentType = async () => {
    try {
      const response = await axiosInstance.get(
        `/paymentterm/edit/${data.payment_term_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
        }
      );
      const fetchedData = response.data.data;
      const formatData = {
        payment_term_name: fetchedData.payment_term_name,
        payment_term_desc: fetchedData.payment_term_desc,
        payment_days: fetchedData.payment_days,
        status: fetchedData.status === 1 ? "Active" : "Inactive",
        business_partner_id: fetchedData.business_partner_id,
      };
      setFormData(formatData);
      setPaymentType(fetchedData);
      console.log(formData, "HSNCODE DATA");
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchPAymentType();
  }, []);

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;

    AddPaymemntTermsInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
   
    try {
      // Confirmation dialog using Swal.fire
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to update this Payment Term?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      });

      if (confirmation.isConfirmed) {
        setLoading(true);
        const payload = {
          payment_term_name: formData?.payment_term_name,
          payment_term_desc: formData?.payment_term_desc,
          payment_days: formData?.payment_days,
          status: formData?.status === "Active" ? 1 : 0,
        };

        if (userType === "superadmin") {
          payload.business_partner_id = formData.business_partner_id;
        } else {
          payload.business_partner_id = businessPartnerId;
        }

        // Make API request to update the payment term
        await axiosInstance.patch(
          `/paymentterm/update/${data.payment_term_id}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${Token}`,
            },
          }
        );
        await Swal.fire({
          title: "Success",
          text: "Payment Terms updated successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/admin/manage-logistic/payment-term");
      }
    } catch (error) {
      console.error("Error updating payment term:", error);
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while processing your request.";
      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  const backNavigate = () => {
    navigate(ROUTES_NAVIGATION.PAYMENTLISTS);
  };

  const AddPaymemntTermsInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
          },
        ]
      : []),
    {
      name: "payment_term_name",
      label: "Name",
      type: "text",
      required: true,
      validation: {
        required: true,
        pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
      },
      gridClass: "col-lg-4",
    },
    {
      name: "payment_term_desc",
      label: "Description",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "payment_days",
      label: "Payment Days",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
      validation: {
        required: true,
        message: "Status is required",
      },
      gridClass: "col-lg-4",
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img onClick={backNavigate} src={backicon} alt="back" />
              <span className="backbtntitle">Edit Payment Terms</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter the payment terms details
              </span>
              <DynamicForm
                formConfig={AddPaymemntTermsInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                onClick={() => {
                  handleFormSubmit(formData);
                }}
                className="submit-btn"
              >
                Submit
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EditPaymentTerms;
